import {
  AssetLogsExportApi,
  NormalizeLogsAtRestApi,
  OrganizationLogsExportApi,
} from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const normalizeLogsAtRestApi = new NormalizeLogsAtRestApi(config);
export const assetLogsExportApi = new AssetLogsExportApi(config);
export const organizationLogsExportApi = new OrganizationLogsExportApi(config);

export const assetLogsRequestInit = { credentials: 'include' as const };
